





































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import type { FormLoja } from '@/models'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { obrigatorio } from '@/shareds/regras-de-form'
import { downloadFilesFromS3 } from '@/shareds/s3/files'
import WrapperDeUpload from '@/components/ui/WrapperDeUpload.vue'
import RevealPasswordField from '@/components/ui/RevealPasswordField.vue'
import SeletorDeCfop from '@/components/fiscal/SeletorDeCfop.vue'
import SeletorDeRegimeFiscal from '@/components/fiscal/SeletorDeRegimeFiscal.vue'

@Component({
	components: { WrapperDeUpload, RevealPasswordField, SeletorDeCfop, SeletorDeRegimeFiscal },
})
export default class SecaoDadosFiscais extends Vue {
	@Prop({ type: Object, required: true }) loja!: FormLoja

	AlertModule = AlertModule
	obrigatorio = obrigatorio
	baixandoCertificado = false

	get pastaDoCertificado() {
		if (!this.loja.cnpj) return ''
		return `certificado-nfe/${this.loja.cnpj.replace(/[^A-Za-z0-9]/g, '').toUpperCase()}`
	}

	get nomeDoCertificado() {
		if (!this.loja.cnpj) return 'Loja deve ter um cnpj'
		if (!this.loja.urlCertificadoNfe) return 'Nenhum certificado selecionado...'
		return decodeURI(this.loja.urlCertificadoNfe.split('/').pop() as string)
	}

	async baixarCertificado() {
		const url = this.loja.urlCertificadoNfe
		if (!url) return AlertModule.setError('Não possui certificado configurado para download.')
		try {
			this.baixandoCertificado = true
			// O caminho já inclui o subdomínio, por isso caminhoDaPastaAbsoluto=true
			const caminhoDaPasta = url.replace(/.*\/([^/]+\/[^/]+\/[^/]+)\/[^/]+$/, '$1')
			const nomeDoArquivo = url.substring(url.lastIndexOf('/') + 1)
			await downloadFilesFromS3(caminhoDaPasta, nomeDoArquivo, true)
		} catch (error) {
			AlertModule.setError('Houve um problema ao baixar o arquivo')
		} finally {
			this.baixandoCertificado = false
		}
	}
}
